import { Permission, TicketLineDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import * as SalesStore from '../SalesStore';
import { editLineRemovedIngredients } from './editLineComposition';

declare global {
	interface CommandType {
		adjustTicketLineIngredients: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('adjustTicketLineIngredients', Preconditions.ensure(Permission.Ticket_AdjustIngredients), async (line: TicketLineDTO): Promise<Result> => {

	const result = await editLineRemovedIngredients(line);

	if (!result.ok)
		return Result.error();

	await SalesStore.adjustIngredients(line.Id, result.value.removedIngredients);
	await CustomerDisplay.displayExistingLine(SalesStore.getTicket(), SalesStore.getLineById(line.Id));

	return Result.ok();
});